import { AddressResponse, InsuredLocationAddress, QuoteLocationAddress } from '@models/customer';
import { PolicyAddress } from '@models/policy';
import { EnteredAddress, ValidAddressItem } from '@models/validation';

export const initialAddressState: EnteredAddress = {
  street1: '',
  street2: '',
  state: '',
  city: '',
  zipCode: '',
};

type OtherAddressType = PolicyAddress | EnteredAddress | AddressResponse | InsuredLocationAddress;

const getAddressData = (address: QuoteLocationAddress | ValidAddressItem | OtherAddressType) => {
  const { street1, street2, city } = address;
  let state = '';
  let zipCode = '';
  if (Object.keys(address).includes('jurisdiction')) {
    state = (address as QuoteLocationAddress).jurisdiction.abbreviation;
    zipCode = (address as QuoteLocationAddress).zipCode;
  } else if (Object.keys(address).includes('zipcode')) {
    state = (address as ValidAddressItem).state;
    zipCode = (address as ValidAddressItem).zipcode;
  } else if (Object.keys(address).includes('zipCode')) {
    state = (address as OtherAddressType).state;
    zipCode = (address as OtherAddressType).zipCode;
  }
  return { street1, street2, city, state, zipCode };
};

export const formatAddress = (address: QuoteLocationAddress | ValidAddressItem | OtherAddressType | EnteredAddress) => {
  const addressData = getAddressData(address);
  const { street1, street2, city, state, zipCode } = addressData;

  if (!street1 && !city && !state && !zipCode) {
    return '-';
  }
  return `${street1 ?? '-'}, ${street2 ? `${street2}, ` : ''}${city ?? '-'}, ${state ?? '-'} ${zipCode ?? '-'}`;
};

export const formatTwoLineAddress = (address: QuoteLocationAddress | ValidAddressItem | OtherAddressType) => {
  const addressData = getAddressData(address);
  const { street1, street2, city, state, zipCode } = addressData;
  return [`${street1}${street2 ? `, ${street2}` : ''}`, `${city}, ${state} ${zipCode}`];
};

export const areAddressesEqual = (option: EnteredAddress | QuoteLocationAddress, value: EnteredAddress) => {
  let selectedOption = '';
  if (Object.keys(option).includes('state')) {
    const { street1, street2, city, state, zipCode } = option as EnteredAddress;
    selectedOption = `${street1}|${street2 || ''}|${city}|${state}|${zipCode}`;
  } else if (Object.keys(option).includes('jurisdiction')) {
    const { street1, street2, city, jurisdiction, zipCode } = option as QuoteLocationAddress;
    selectedOption = `${street1}|${street2 || ''}|${city}|${jurisdiction.abbreviation}|${zipCode}`;
  }
  const { street1, street2, city, state, zipCode } = value;
  const selectedValue = `${street1}|${street2 || ''}|${city}|${state}|${zipCode}`;
  return selectedOption.replaceAll(' ', '').toLowerCase() === selectedValue.replaceAll(' ', '').toLowerCase();
};

export const getAddressFromQuoteItemAttributeTypes = (quoteItem: any) => {
  const { AddressCity, AddressState, AddressStreet, AddressStreet2, AddressZip } = quoteItem.attributeTypes;

  return `${AddressStreet?.attribute?.value} ${AddressStreet2?.attribute?.value ? AddressStreet2?.attribute?.value + ', ' : ''} ${AddressCity?.attribute?.value}, ${AddressState?.attribute?.value}, ${AddressZip?.attribute?.value}`;
};
